/**
 * Layout constants for dashboard, header, SlideOutModal and NotificationBar.
 * Tailwind JIT requires literal class names (no dynamic templates).
 * Spacing scale: 1 unit = 4px → top-14=56px, top-21=84px, top-35=140px.
 */
export const HEADER_HEIGHT_PX = 84;
export const NOTIFICATION_BAR_HEIGHT_PX = 56;

export const LAYOUT = {
    /** Header position when notification bar is hidden */
    headerTopWithoutNotification: "top-0",
    /** Header position when notification bar is visible (56px) */
    headerTopWithNotification: "top-14",
    /** Header fixed height (84px) */
    headerHeight: "h-21",
    /** Modal panel top offset: below header only (84px) */
    modalTopWithoutNotification: "top-21",
    /** Modal panel top offset: below header + notification bar (140px) */
    modalTopWithNotification: "top-35",
    /** Content padding to account for fixed header height */
    contentPaddingTop: "pt-21",
} as const;

export type HeaderTopOffset =
    | typeof LAYOUT.headerTopWithoutNotification
    | typeof LAYOUT.headerTopWithNotification;

export type ModalTopOffset =
    | typeof LAYOUT.modalTopWithoutNotification
    | typeof LAYOUT.modalTopWithNotification;
